var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mds-layout-grid',[_c('filter-section'),_c('header-section'),_c('TableSectionEM')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }